export const FETCH_CLIENT_CREDENTIALS = 'FETCH_CLIENT_CREDENTIALS';
export const FETCH_CLIENT_CREDENTIALS_SUCCESS =
    'FETCH_CLIENT_CREDENTIALS_SUCCESS';
export const FETCH_CLIENT_CREDENTIALS_FAIL = 'FETCH_CLIENT_CREDENTIALS_FAIL';

export const SET_CLIENT_BRANDS = 'SET_CLIENT_BRANDS';
export const SET_CLIENT_BRANDS_SUCCESS = 'SET_CLIENT_BRANDS_SUCCESS';
export const SET_CLIENT_BRANDS_FAIL = 'SET_CLIENT_BRANDS_FAIL';
